import OutletWithDefaultElectionContext from './OutletWithDefaultElectionContext';
import RegionAccessCode from './RegionAccessCode';

function RegionWrapper() {
    return (
        <RegionAccessCode>
            <OutletWithDefaultElectionContext />
        </RegionAccessCode>
    );
}

export default RegionWrapper;
